export default "__VITE_ASSET__23467271__"